const state = {
  ...window.__initialAppState.modules.accountPage
};

export default state;
